<template>
    <!-- Loading state -->
    <div v-if="loading" class="kpi-block kpi-block--static">
        <dt class="kpi-block__title">
            <span class="inline-block w-24 h-4 rounded animate-pulse bg-neutral-200 dark:bg-neutral-700"></span>
        </dt>
        <dd class="kpi-block__value">
            <span class="inline-block w-16 h-8 rounded animate-pulse bg-neutral-200 dark:bg-neutral-700"></span>
        </dd>
    </div>

    <!-- Clickable variant -->
    <inertia-link v-else-if="href" :href="href" class="kpi-block kpi-block--clickable">
        <dt class="kpi-block__title">
            {{ title }}
            <span v-if="period" class="kpi-block__period">({{ period }})</span>
        </dt>
        <dd class="kpi-block__value">
            <slot>{{ value }}</slot>
        </dd>
    </inertia-link>

    <!-- Static variant -->
    <div v-else class="kpi-block kpi-block--static">
        <dt class="kpi-block__title">
            {{ title }}
            <span v-if="period" class="kpi-block__period">({{ period }})</span>
        </dt>
        <dd class="kpi-block__value">
            <slot>{{ value }}</slot>
        </dd>
    </div>
</template>

<script setup lang="ts">
interface Props {
    title: string;
    value?: string | number;
    period?: string;
    href?: string;
    loading?: boolean;
}

withDefaults(defineProps<Props>(), {
    value: '',
    period: undefined,
    href: undefined,
    loading: false,
});
</script>
